// packages

// components

// api

// styles
import './PNPLogo.scss';

const PNPLogo = () => {
  return (
    <div className='PNPLogo'>
      <h5 className='me-4'>GOVPH</h5>
      <img
        alt='img'
        src='./logo.png'
      />
    </div>
  );
};

export default PNPLogo;
